import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@ngneat/transloco';
import { UtilsService } from '@shared/services/utils.service';
import { CoreService } from '@core/services';

@Component({
  selector: 'app-route-form-header',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslocoPipe],
  templateUrl: './route-form-header.component.html',
  styleUrls: ['./route-form-header.component.scss']
})
export class RouteFormHeaderComponent {

  private coreService = inject(CoreService);
  public isMobile = inject(UtilsService).isMobile;
  
  public closeSidenav() {
    this.coreService.sidenavOpened.set(false);
  }

}
